/**
 *  v-ossImg
 *  通过oss上传的图片请用请指令回显
 *
 *  binding.value { name, authType, size, }
 *  @param  name        String          阿里云OSS文件name (例: 'maintain/201912/xxx.png')
 *  @param  authType    String          (选填, 默认值为'PUBLIC') 存储空间类型 (PUBLIC - 公共读; PRIVATE - 私有读)
 *  @param  size        Number          (选填) 图片独有参数, 设置需要的图片宽度 (例: 100)
 */
import oss from '@/utils/oss';

async function handleImgLoad(el, binding) {
    try {
        const { name, authType, size } = binding.value;
        if (!name) return;

        const res = await oss.downloadFile(name, authType, size);
        el.setAttribute('src', res);
    } catch (err) {
        throw new Error(err);
    }
}

export default {
    name: 'ossImg',
    inserted(el, binding) {
        handleImgLoad(el, binding);
    },
    update(el, binding) {
        const { name, authType, size } = binding.value;
        const { name: oldName, authType: oldAuthType, size: oldSize } = binding.oldValue;

        if (name !== oldName || authType !== oldAuthType || size !== oldSize) handleImgLoad(el, binding);
    },
};
